// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"xS-z","categoryName":"yS-z","categoryNameSearchHeader":"zS-z","categoryContent":"AS-z","bottomAligned":"BS-z","image":"CS-z","imageNoBackground":"DS-z"};